module.exports = __webpack_public_path__ + "img/menus-blue-new.5ab4e742.svg";